import { SmallSearchIcon } from '@orn/shared-web/icons';

import KbdHint from '../KbdHint';

import { useCommandPalette } from './CommandPaletteProvider';

/**
 * A stand-in for the command palette, styled as a search box: focusing or
 * clicking it opens the palette, which takes the focus and the typing. It never
 * holds text of its own, so its placeholder can teach the shortcut with key
 * caps a native placeholder cannot draw.
 *
 * A button rather than a read-only input because opening a dialog is what it
 * does. It opens on click as well as focus because Safari does not focus a
 * button that is clicked.
 */
const CommandPaletteTrigger = () => {
  const { setIsOpen } = useCommandPalette();
  const open = () => setIsOpen(true);

  return (
    <button
      type="button"
      aria-label="Open the command palette"
      aria-haspopup="dialog"
      aria-keyshortcuts="Meta+K"
      onFocus={open}
      onClick={open}
      className="border-border-primary bg-bg-primary text-fg-quaternary focus-visible:outline-border-brand flex w-96 cursor-text items-center gap-2 border px-2.5 py-1.5 text-left font-mono text-xs focus-visible:outline-2 focus-visible:-outline-offset-1"
    >
      <SmallSearchIcon className="size-4 shrink-0" />
      <span className="truncate">
        Press <KbdHint>⌘</KbdHint>
        <KbdHint>K</KbdHint> to jump to a tool, user, or id…
      </span>
    </button>
  );
};

export default CommandPaletteTrigger;
